import { colors } from "../../../data/colors";
import { emptys } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import convertDate from "../../../utils/convertDate";
import { openPrinterDialog } from "./stationery/openPrinterDialog";

export const openFormDialog = async (codes: stdObject, params: stdObject) => {
  const { paper, title } = codes;
  const {
    t,
    user,
    docValues,
    setMsg,
    setModalData,
    setDocValues,
    setStationeryModal,
    closeMsg,
    logoutAction,
  } = params;
  try {
    let formsData: stdObject = {
      title: title ?? t("p.forms"),
      key: "paper",
      value: "CODDOC",
      new: false,
    };
    const paperCode = emptys.includes(paper)
      ? docValues.forms[0].CODDOC
      : paper;
    if (paper || docValues.forms.length === 1) {
      setMsg("loading");
      const payloadFormDialog: stdObject = {
        branch: user.CODSUC,
        paper: paperCode,
        doc: docValues.code,
      };
      console.log("payloadFormDialog", payloadFormDialog);
      const responseFormDialog: stdObject = await sendData({
        endPoint: "callFormList",
        payload: payloadFormDialog,
        logoutAction,
      });
      console.log("responseFormDialog", responseFormDialog);
      formsData = {
        title: emptys.includes(paper) ? docValues.forms[0].NOMDOC : title,
        table: responseFormDialog.list.map((e: stdObject) => {
          return {
            data: [convertDate({ info: e.FECDO0, t })],
            onClick: () => {
              setModalData({});
              closeMsg();
              openPrinterDialog(
                {
                  sectionType: {
                    id: docValues.sectionId,
                    code: docValues.type,
                  },
                  data: {
                    [`SER${docValues.type}`]:
                      docValues.data[`SER${docValues.type}`].value,
                    [`COD${docValues.type}`]:
                      docValues.data[`COD${docValues.type}`].value,
                  },
                  type: docValues.typeText,
                  formCode: paperCode,
                  formId: e.CODDO0,
                },
                {
                  setDocValues,
                  setStationeryModal,
                  setMsg,
                  closeMsg,
                  logoutAction,
                },
              );
            },
          };
        }),
        key: "doc",
        value: "CODDO0",
        new: true,
      };
    } else {
      formsData.table = docValues.forms.map((e: stdObject) => {
        return {
          data: [e.NOMDOC],
          onClick: () =>
            openFormDialog(
              {
                ...codes,
                title: e.NOMDOC,
                [formsData.key]: e[formsData.value],
              },
              params,
            ),
        };
      });
    }
    setMsg("custom1");
    setModalData({
      title: formsData.title,
      table: formsData.table,
      buttons: [
        formsData.new
          ? {
              label: t("p.new"),
              onClick: () => {
                setModalData({});
                closeMsg();
                openPrinterDialog(
                  {
                    sectionType: {
                      id: docValues.sectionId,
                      code: docValues.type,
                    },
                    data: {
                      [`SER${docValues.type}`]:
                        docValues.data[`SER${docValues.type}`].value,
                      [`COD${docValues.type}`]:
                        docValues.data[`COD${docValues.type}`].value,
                    },
                    type: docValues.typeText,
                    formCode: paperCode,
                  },
                  {
                    setDocValues,
                    setStationeryModal,
                    setMsg,
                    closeMsg,
                    logoutAction,
                  },
                );
              },

              color: colors.green,
            }
          : undefined,
        {
          label: t("p.cancel"),
          onClick: () => {
            setModalData({});
            closeMsg();
          },

          color: colors.darkGrey,
        },
      ],
    });
    /*const responseFormDialog: stdObject = await sendData({
        endPoint: "callStationery",
        payload: payloadFormDialog,
        logoutAction,
      });
      console.log("responseFormDialog", responseFormDialog);
      if (responseFormDialog.success && responseFormDialog.status) {
        if (
          responseFormDialog.data.TIPDOC === "SEV" &&
          responseFormDialog.data.ADSDOC
        ) {
          const servItem = responseFormDialog.rows.reduce(
            (acc: stdObject, curr: string) => {
              let value: string | number | any[] = 0;
              switch (curr) {
                case "SERSE0":
                  value = responseFormDialog.documentData.SERSEV;
                  break;
                case "CODSE0":
                  value = responseFormDialog.documentData.CODSEV;
                  break;
                case "ARTSE0":
                  value = responseFormDialog.documentData.INTSEV;
                  break;
                case "NOMSE0":
                  value = responseFormDialog.documentData.INTNSEV;
                  break;
                case "DESSE0":
                  value = responseFormDialog.documentData.DESSEV;
                  break;
                case "IMPSE0":
                  value = responseFormDialog.documentData.PIMSEV;
                  break;
                case "PRESE0":
                case "TOTSE0":
                  value = responseFormDialog.documentData.PRESEV;
                  break;
                case "TIPSE0":
                case "CANSE0":
                case "PENSE0":
                  value = 1;
                  break;
                case "GARSE0":
                case "HUESE0":
                case "CNOSE0":
                case "PIASE0":
                case "UNISE0":
                case "OBSSE0":
                  value = "";
                  break;
              }
              return { ...acc, [curr]: value };
            },
            {},
          );
          servItem.BATCHES = [];
          responseFormDialog.lines.unshift(servItem);
        }

        openStationery({
          type: sectionType.code,
          area: responseFormDialog.area,
          data: responseFormDialog.data,
          parts: responseFormDialog.parts,
          doc: responseFormDialog.doc,
          rows: responseFormDialog.rows,
          person: responseFormDialog.person,
          payments: responseFormDialog.payments,
          documentData: responseFormDialog.documentData,
          formats: responseFormDialog.formats,
          branch: responseFormDialog.branch,
          personData: responseFormDialog.personData,
          lines: responseFormDialog.lines,
          paymentsData: responseFormDialog.paymentsData,
          mainColor: colors[type],
          sectionId: sectionType.id,
          typeText: type,
          index: -1,
        });
      }*/
  } catch (error) {
    console.log("openPrinterDialog error: ", error);
    closeMsg();
  }
};
